document.addEventListener('DOMContentLoaded', function () {
  function cleanInvalidAriaSelected() {
    document
      .querySelectorAll('.flickity-slider > [aria-selected], .gallery-cell[aria-selected], .logo-list__item[aria-selected]')
      .forEach(function (el) {
        if (!el.hasAttribute('role')) {
          el.removeAttribute('aria-selected');
        }
      });
  }

  cleanInvalidAriaSelected();

  const observer = new MutationObserver(cleanInvalidAriaSelected);
  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-selected']
  });

  if (window.utils && typeof window.utils.createAccordion === 'function') {
  window.utils.createAccordion('.footer_menu', '.footer-heading', 'ul');
}
});

function enhanceCartQuantityControls() {
  document.querySelectorAll('.js-change-quantity').forEach(function (control) {
    if (!control.hasAttribute('role')) {
      control.setAttribute('role', 'button');
    }

    if (!control.hasAttribute('tabindex')) {
      control.setAttribute('tabindex', '0');
    }

    if (!control.hasAttribute('aria-label')) {
      if (control.classList.contains('product-minus')) {
        control.setAttribute('aria-label', 'Decrease quantity');
      }

      if (control.classList.contains('product-plus')) {
        control.setAttribute('aria-label', 'Increase quantity');
      }
    }

    if (!control.dataset.keyboardReady) {
      control.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          control.click();
        }
      });

      control.dataset.keyboardReady = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', enhanceCartQuantityControls);

const quantityObserver = new MutationObserver(enhanceCartQuantityControls);

quantityObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Redirect to full cart after successful AJAX Add to Cart.
// Avoids Turbo's Mini Cart accessibility issues.

jQuery(document).ajaxSuccess(function(event, xhr, settings) {
  if (settings.url.includes('/cart/add.js') && xhr.status === 200) {
    window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
  }
});

/* Open Helpify widget from Customer Support links *//* Open Helpify email form from Customer Support links */
document.addEventListener('click', function(event) {
  const link = event.target.closest('.modkat-support-link');
  if (!link) return;

  const root = document.querySelector('#helply-agent-root-container')?.shadowRoot;
  const trigger = root?.querySelector('button[aria-label="AI agent trigger"]');

  // Preserve the email fallback if Helpify is unavailable.
  if (!root || !trigger) return;

  event.preventDefault();

  // Open the widget if it is currently closed.
  if (trigger.getAttribute('aria-expanded') !== 'true') {
    trigger.click();
  }

  let attempts = 0;

  const interval = setInterval(() => {
    attempts++;

    const nameField = root.querySelector('input#handoverUsername');

    if (nameField && nameField.getClientRects().length) {
      clearInterval(interval);
      nameField.focus();
      return;
    }

    const emailButton = [...root.querySelectorAll('button, [role="button"]')]
      .find(el =>
        el.textContent.trim().includes('Email Customer Support') &&
        el.getClientRects().length
      );

    if (emailButton) {
      emailButton.click();
    }

    if (attempts >= 30) {
      clearInterval(interval);
      console.warn('Helpify email form could not be opened.');
    }
  }, 200);
});

// HelpLy widget keyboard focus indicator.
// Adds a visible blue focus ring with white separation
// so it remains visible against black and white backgrounds.

(function () {
  function fixHelplyFocus() {
    const host = document.querySelector('#helply-agent-root-container');
    if (!host || !host.shadowRoot) return false;

    const root = host.shadowRoot;

    if (root.querySelector('#modkat-helply-focus')) return true;

    const style = document.createElement('style');
    style.id = 'modkat-helply-focus';
    style.textContent = `
      button:focus-visible {
        outline: 3px solid #0066FF !important;
        outline-offset: 4px !important;
        box-shadow: 0 0 0 2px #FFFFFF !important;
      }
    `;

    root.appendChild(style);
    return true;
  }

  if (!fixHelplyFocus()) {
    const observer = new MutationObserver(() => {
      if (fixHelplyFocus()) observer.disconnect();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();